import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { CloseAccountComponent } from './close-account.component';


@NgModule({
  declarations: [
    CloseAccountComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule
  ]
})
export class CloseAccountModule {}